// Cache configuration
const CACHE_KEY = 'featured_products_cache';
const CACHE_TIMESTAMP_KEY = 'featured_products_cache_timestamp';
const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

const recommendationsModal = document.querySelector('.recommendations-modal');
const recommendationsModalClose = document.querySelector('.recommendations-modal--close');
const recommendationsModalInner = document.querySelector('.recommendations-modal--inner');
const recommendationsModalContent = document.querySelector('.recommendations-modal--content');
const recommendationsNavItems = document.querySelector('.recommendations-nav-items');

const recommendationsPopup = document.body.getAttribute('data-recommendations-popup');


recommendationsModal.addEventListener('click', (e) => {
    if (e.target === recommendationsModal || e.target === recommendationsModalInner) {
        recommendationsModal.classList.remove('active');
    }
});
recommendationsModalClose.addEventListener('click', () => {
    recommendationsModal.classList.remove('active');
});

// Helper function to add delay
function delay(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

// Helper function to batch fetch with concurrency limit
async function batchFetch(items, fetchFn, batchSize) {
    const results = [];
    for (let i = 0; i < items.length; i += batchSize) {
        const batch = items.slice(i, i + batchSize);
        const batchResults = await Promise.all(batch.map(fetchFn));
        results.push(...batchResults);

        // Add delay between batches (except for the last batch)
        if (i + batchSize < items.length) {
            await delay(100);
        }
    }
    return results;
}

function parseGid(gid) {
    return parseInt(gid.split('/').pop(), 10);
}

function transformStorefrontProduct(node) {
    return {
        id: parseGid(node.id),
        handle: node.handle,
        title: node.title,
        variants: node.variants.edges.map(function (edge) {
            return { sku: edge.node.sku };
        }),
    };
}

async function fetchStorefrontProducts(cursor) {
    const query = `
        query ($cursor: String) {
            products(first: 250, after: $cursor) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        id
                        handle
                        title
                        variants(first: 100) {
                            edges {
                                node {
                                    sku
                                }
                            }
                        }
                    }
                }
            }
        }
    `;

    const response = await fetch(theme.storefront.apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': theme.storefront.accessToken,
        },
        body: JSON.stringify({ query: query, variables: { cursor: cursor || null } }),
    });

    const data = await response.json();

    if (data.errors) {
        throw new Error(data.errors.map(function (error) {
            return error.message;
        }).join(', '));
    }

    return data.data.products;
}

// Function to fetch all products via Storefront GraphQL (with sessionStorage caching)
async function getAllProducts() {
    try {
        // Check sessionStorage cache
        const now = Date.now();
        const cachedData = sessionStorage.getItem(CACHE_KEY);
        const cachedTimestamp = sessionStorage.getItem(CACHE_TIMESTAMP_KEY);

        if (cachedData && cachedTimestamp) {
            const timestamp = parseInt(cachedTimestamp, 10);
            if (now - timestamp < CACHE_DURATION) {
                // console.log('✅ Using cached products from sessionStorage');
                return JSON.parse(cachedData);
            }
        }

        // console.log('🔄 Fetching fresh products...');
        const allProducts = [];
        let cursor = null;
        let hasMore = true;

        while (hasMore) {
            const productsData = await fetchStorefrontProducts(cursor);
            const products = productsData.edges.map(function (edge) {
                return transformStorefrontProduct(edge.node);
            });

            if (products.length > 0) {
                allProducts.push(...products);
            }

            if (productsData.pageInfo.hasNextPage) {
                await delay(150);
                cursor = productsData.pageInfo.endCursor;
            } else {
                hasMore = false;
            }
        }

        // Save to sessionStorage
        try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify(allProducts));
            sessionStorage.setItem(CACHE_TIMESTAMP_KEY, now.toString());
            // console.log('💾 Cached ' + allProducts.length + ' products to sessionStorage');
        } catch (e) {
            console.warn('Failed to cache to sessionStorage:', e);
        }

        return allProducts;
    } catch (error) {
        console.error('Error fetching all products:', error);
        return [];
    }
}

// Start fetching products immediately when script loads
const allProductsPromise = getAllProducts();
allProductsPromise.then(function (products) {
    // console.log('--- allProducts loaded ---', products);
});

document.addEventListener('DOMContentLoaded', async function () {
    // Wait for products to be loaded
    const allProducts = await allProductsPromise;

    // Function to find products by SKU (using cache) - maintains order
    async function findProductsBySKU(skuArray, allProducts) {
        try {
            // Create SKU to product map
            const skuToProductMap = {};

            allProducts.forEach(function (product) {
                if (product.variants) {
                    product.variants.forEach(function (variant) {
                        if (variant.sku) {
                            const variantSKU = variant.sku.trim().toUpperCase();
                            // Store first occurrence only
                            if (!skuToProductMap[variantSKU]) {
                                skuToProductMap[variantSKU] = product;
                            }
                        }
                    });
                }
            });

            // Map products in the same order as input SKUs
            const matchedProducts = [];
            const foundProductIds = new Set();

            skuArray.forEach(function (sku) {
                const product = skuToProductMap[sku];
                if (product && !foundProductIds.has(product.id)) {
                    matchedProducts.push(product);
                    foundProductIds.add(product.id);
                }
            });

            return matchedProducts;
        } catch (error) {
            console.error('Error during search:', error);
            return [];
        }
    }

    // Function to process each featured products container
    async function processFeaturedProductsContainer(container, index, allProducts) {
        const skuString = container.getAttribute('data-product-skus');

        if (!skuString) {
            console.warn(`No SKUs found for container ${index}`);
            return;
        }

        const skus = skuString.split(',').map(function (s) {
            return s.trim().toUpperCase();
        });

        try {
            const products = await findProductsBySKU(skus, allProducts);

            if (products.length === 0) {
                container.innerHTML = '';
                return;
            }

            // Create featured structure
            const featuredContainer = document.createElement('div');
            featuredContainer.className = `featured-products-list featured-products-list-${index}`;

            const featuredWrapper = document.createElement('div');
            featuredWrapper.className = 'featured-products-list-wrapper';

            featuredContainer.appendChild(featuredWrapper);

            // Batch fetch products to limit concurrent requests (max 8 at a time)
            const results = await batchFetch(
                products,
                function (product) {
                    const searchUrl = `/search?view=featured-products&type=product&q=id:${product.id}`;
                    return fetch(searchUrl)
                        .then(function (response) {
                            if (response.ok) {
                                return response.text().then(function (text) {
                                    return { product: product, html: text };
                                });
                            } else {
                                console.error(
                                    'Failed to fetch search results:',
                                    product.handle,
                                    response.status
                                );
                                return null;
                            }
                        })
                        .catch(function (error) {
                            console.error('Error fetching product:', product.handle, error);
                            return null;
                        });
                },
                8 // Process 8 products at a time (increased from 5)
            );

            // Sort results to maintain the same order as input products
            const productIdToIndex = {};
            products.forEach(function (product, idx) {
                productIdToIndex[product.id] = idx;
            });

            results.sort(function (a, b) {
                if (!a) return 1;
                if (!b) return -1;
                const indexA = productIdToIndex[a.product.id] || 0;
                const indexB = productIdToIndex[b.product.id] || 0;
                return indexA - indexB;
            });

            // Process results and create slides
            const fragment = document.createDocumentFragment();

            results.forEach(function (result) {
                if (result && result.html) {
                    const html = document.createElement('div');
                    html.innerHTML = result.html;

                    // Find product card
                    const productCard = html.querySelector('.product-card');

                    if (productCard) {
                        // Create featured slide
                        const featuredItem = document.createElement('div');
                        featuredItem.className = 'featured-products-list-item';

                        featuredItem.appendChild(productCard.cloneNode(true));

                        // Add to fragment
                        fragment.appendChild(featuredItem);
                    } else {
                        console.warn('⚠️ Product card not found for:', result.product.title);
                    }
                }
            });

            // Add all slides at once
            featuredWrapper.appendChild(fragment);

            // Clear container and add featured
            container.innerHTML = '';
            container.appendChild(featuredContainer);
        } catch (error) {
            console.error(`Error processing container ${index}:`, error);
        }
    }

    // Process all featured products containers (2 at a time for speed)
    async function processAllContainers(area, allProducts, productId) {
        const containerIds = [0, 1, 2, 3, 4, 5, 6, 7, 8 ];
        const batchSize = 2; // Process 2 containers at a time

        for (let i = 0; i < containerIds.length; i += batchSize) {
            const batch = containerIds.slice(i, i + batchSize);

            // Process batch in parallel
            await Promise.all(
                batch.map(function (id) {
                    const container = area.querySelector('#featured-products-' + id + '-' + productId);
                    if (container) {
                        return processFeaturedProductsContainer(container, id, allProducts);
                    }
                    return Promise.resolve();
                })
            );

            // Add delay between batches (except for the last batch)
            if (i + batchSize < containerIds.length) {
                await delay(200); // Reduced from 300ms to 200ms
            }
        }
    }

    // Start processing
    if (document.querySelectorAll('.featured-products-collapsible-content').length > 0) {
        const area = document.querySelector('.product-detail-main-container');
        const productId = area.getAttribute('data-product-id');
        // console.log('productId', productId);
        processAllContainers(area, allProducts, productId);
    }

    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('recommendations-nav-item')) {
            e.preventDefault();
            const target = e.target.getAttribute('href');
            const content = document.querySelector(target);
            const contentNavItems = document.querySelectorAll('.recommendations-nav-item');
            contentNavItems.forEach((item) => {
                item.classList.remove('active');
            });
            e.target.classList.add('active');

            const contentItems = document.querySelectorAll('.recommendations-modal--content-item');
            contentItems.forEach((item) => {
                item.style.display = 'none';
            });
            if (content) {
                content.style.display = 'block';
            }
            recommendationsModalContent.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    });

    // Listen for cart item added event to log recommendations data
    
    document.addEventListener('cart:item-added', (e) => {
        if (recommendationsPopup == "true") {
            // console.log('cart:item-added', e);
            let button = null;
            const productId = e.detail.product.id;

            // Check if event came from product form
            if (e.detail?.form) {
                button = e.detail.form.querySelector('.recommendations-add-to-cart-button');
            }
            // Check if event came from quick add button
            else if (e.detail?.button) {
                button = e.detail.button.classList.contains('recommendations-add-to-cart-button')
                    ? e.detail.button
                    : null;
            }

            if (!button) {
                return;
            }
            // console.log('button', button);
            const textarea = button.querySelector('.recommendations-data');
            // console.log('textarea', textarea);
            if (textarea) {
                const recommendationsData = textarea.value;
                if (recommendationsData) {
                    try {
                        const data = JSON.parse(recommendationsData);

                        // console.log('json data', data);
                        if (data.length > 0) {
                            recommendationsNavItems.innerHTML = '';
                            recommendationsModalContent.innerHTML = '';
                            data.forEach((item, index) => {
                                const title = item.title;
                                recommendationsNavItems.innerHTML += `<a class="recommendations-nav-item ${
                                    index == 0 ? 'active' : ''
                                }" href="#featured-products-${index + 1}-${productId}">${title}</a>`;
                            });

                            data.forEach((item, index) => {
                                recommendationsModalContent.innerHTML += `<div class="recommendations-modal--content-item" id="featured-products-${
                                    index + 1
                                }-${productId}" data-product-skus="${item.skus}" style="display: ${
                                    index == 0 ? 'block' : 'none'
                                }"><div class="loading-dots"><span></span><span></span><span></span><span></span></div></div>`;
                            });
                            processAllContainers(recommendationsModalContent, allProducts, productId);
                            recommendationsModal.classList.add('active');
                        }

                    } catch (error) {
                        console.error('Error parsing recommendations data:', error);
                        // console.log('Raw data:', recommendationsData);
                    }
                }
                
            }
        }
    });
});